// Expose punycode and ColorThief to the window browser object
import 'expose-loader?exposes=punycode!punycode';
import 'expose-loader?exposes=ColorThief!color-thief-browser';
import PkgActivity from '../common/models/PkgActivity';
import ActivityTag from '../common/models/ActivityTag';
import ActivityReward from '../common/models/ActivityReward';
import GuessGame from '../common/models/GuessGame';

import app from './app';

export { app };

// Export compat API
import compatObj from './compat';
import proxifyCompat from '../common/utils/proxifyCompat';
import User from '../common/models/User';
import Model from '../common/Model';

User.prototype.notHideChangePwd = Model.attribute('notHideChangePwd');
app.store.models.pkgActivityCategories = PkgActivity;
app.store.models.activityTagCategories = ActivityTag;
app.store.models.activityRewardCategories = ActivityReward;
app.store.models.GuessGame = GuessGame;


// @ts-ignore
compatObj.app = app;

export const compat = proxifyCompat(compatObj, 'forum');
